import script from "./AddHall.vue?vue&type=script&setup=true&lang=js"
export * from "./AddHall.vue?vue&type=script&setup=true&lang=js"

import "./AddHall.vue?vue&type=style&index=0&id=3043e376&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3043e376"]])

export default __exports__